import { render, staticRenderFns } from "./toDetermine.vue?vue&type=template&id=22153880&scoped=true&"
import script from "./toDetermine.vue?vue&type=script&lang=js&"
export * from "./toDetermine.vue?vue&type=script&lang=js&"
import style0 from "./toDetermine.vue?vue&type=style&index=0&id=22153880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22153880",
  null
  
)

export default component.exports